import { ReactElement, ReactNode } from 'react'
import styles from '../styles/StageText.module.css'

interface Props {
  children: ReactNode
}

const StageText = ({ children }: Props): ReactElement => {
  return (
    <div className={styles.text}>
      {children}
    </div>
  )
}

export default StageText
